import React from 'react';
const bonuses = [{
  number: 1,
  title: 'Protocolo de Salida Sin Drama',
  description: 'Guiones exactos para cerrar el vínculo con autoridad y sin culpa.',
  value: '$17 USD',
  image: 'https://cdn.magicpatterns.com/uploads/4AkdCmEVQTspDeD7wkQVNV/IMG_8502.jpg'
}, {
  number: 2,
  title: 'Escáner Digital de 15 Minutos',
  description: 'Tu filtro de seguridad para saber si vale la pena salir de casa o si debes bloquearlo ahora.',
  value: '$17 USD',
  image: 'https://cdn.magicpatterns.com/uploads/2uLS1x4rixSoS7FeGi16FA/IMG_8498.jpg'
}, {
  number: 3,
  title: 'Detox de Claridad Emocional (7 Días)',
  description: 'Resetea tu criterio para pasar del modo "esperanza" al modo "certeza total".',
  value: '$12 USD',
  image: 'https://cdn.magicpatterns.com/uploads/rZ3ADSMVas9wtNP7hDpoC7/Brown_and_Gray_Minimalist_Tablet_Mockup_Instagram_Post.jpg'
}];
export function BonusesSection() {
  return <section className="px-5 pt-0 pb-0 max-w-[640px] mx-auto -mt-4" data-id="element-18">
      <div className="text-center pt-0 pb-2" data-id="element-19">
        <span className="text-4xl block mb-2" data-id="element-20">🎁</span>
        <span className="text-[11px] font-bold tracking-widest text-[var(--accent)]" data-id="element-21">
          BONOS EXCLUSIVOS DE LANZAMIENTO
        </span>
      </div>

      <div className="flex flex-col gap-2.5" data-id="element-22">
        {bonuses.map(bonus => <div key={bonus.number} className="bg-[var(--card)] rounded-2xl p-4 border border-[var(--border)] overflow-hidden" data-id="element-23">
            <div className="flex justify-between items-center mb-2 px-1" data-id="element-24">
              <span className="bg-[var(--red2)] text-white text-[10px] font-bold px-2.5 py-0.5 rounded-md" data-id="element-25">
                BONO {bonus.number}
              </span>
              <span className="text-[11px] font-bold text-[var(--accent)] tracking-wider" data-id="element-26">
                GRATIS
              </span>
            </div>

            <div className="flex items-center gap-4" data-id="element-27">
              <img src={bonus.image} alt={bonus.title} className="w-[155px] h-[180px] flex-shrink-0 rounded-lg object-contain" data-id="element-28" />
              <div className="flex-1 min-w-0" data-id="element-29">
                <h3 className="text-[15px] font-bold mb-1" data-id="element-30">{bonus.title}</h3>
                <p className="text-white text-[13px] leading-snug mb-2" data-id="element-31">
                  {bonus.description}
                </p>
                <div className="flex justify-between border-t border-[var(--border)] pt-2" data-id="element-32">
                  <span className="text-xs text-[var(--muted)]" data-id="element-33">
                    Valor real
                  </span>
                  <span className="text-sm font-bold text-[var(--accent)] line-through" data-id="element-34">
                    {bonus.value}
                  </span>
                </div>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}